export default "/images/922e9ffda876eaa881226d003d1b7164.avif";